import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the SearchChangePipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'searchChange',
})
export class SearchChangePipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(value: string,keyword:any, ...args) {

    value = value.replace(eval('/'+keyword + '/g'),"<span class='font-red '>$&</span>");
    return value
  }
}



// WEBPACK FOOTER //
// ./src/pipes/search-change/search-change.ts